import { Button, IconButton, useMediaQuery } from "@mui/material";
import React from "react";
// import { Container } from './styles';
import { FiPlus } from "react-icons/fi";

const GradientButton: React.FC<any> = ({ onClick, disabled }) => {
  const larguraTelaPequena = useMediaQuery("(max-width:1300px)");
  const estilo = {
    background: "linear-gradient(to right, #4a76fb, #06d986)",
    color: "white",
  };
  return larguraTelaPequena ? (
    <IconButton
      onClick={onClick}
      sx={estilo}
      style={{ marginRight: 8, borderRadius: 4, opacity: disabled ? 0.5 : 1 }}
      disabled={disabled}
    >
      <FiPlus color="#fff" size={22} />
    </IconButton>
  ) : (
    <Button
      onClick={onClick}
      sx={estilo}
      style={{
        color: "#fff",
        marginRight: 8,
        textTransform: "none",
        boxShadow: "none",
      }}
      variant="contained"
    >
      <FiPlus color="#fff" size={18} style={{ marginRight: 8 }} />
      Novo atendimento
    </Button>
  );
};

export default GradientButton;
